export default __webpack_public_path__ + "static/media/loader.dcd6327c.svg";